import api from "./api";

export function getStudyPage(country_id) {
  return api.get(`/studypage/${country_id}`);
}

export function createStudyPage(data) {
  return api.post("/studypage", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateStudyPage(country_id, data) {
  return api.put(`/studypage/${country_id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
